const menus = [
  {
    index: 1,
    name: 'Ambiente'
  },
  {
    index: 2,
    name: 'Preferências'
  },
  {
    index: 3,
    name: 'Tamanho'
  },
  {
    index: 4,
    name: 'Preço'
  },
];

export default menus;